// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/single-product';
import woocommerceCheckout from './routes/woocommerce-checkout';
import woocommerceCart from './routes/woocommerce-cart';
import taxonomyData from './routes/taxonomy-data';
import pedidos from './routes/pedidos';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  singleProduct,
  woocommerceCheckout,
  woocommerceCart,
  taxonomyData,
  pedidos,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js